import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr0046',
    ecrans: ['00-2'],
    params: [
        'scbcleint'
    ]
});
